import React from "react";
import "./Footer.css";

export function Footer() {
    return (
        <p className="footer">Hecho con 💡 por <a href="https://github.com/MauricioJCarrillo/8.curso_practico_html_y_css_platzi">@MauricioJCarrillo</a></p>
    );      
}